/* eslint-disable no-unused-vars */
/**
 * @file user.roles.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene los enums de los roles de usuario
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2024-12-19
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 * */

export enum UserRoles {
  USER = "user",
  ADMIN = "admin",
}
